import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/design-system.css';
import './main.css';
import './styles/native.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import './i18n';
import { Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { initCapacitor } from './native/capacitorInit';

// Native (Capacitor) init — no-op on web.
initCapacitor();

const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const loadGoogleMapsApi = (key) => {
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
};

loadGoogleMapsApi(googleMapsApiKey);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Suspense fallback={<div>Loading...</div>}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Suspense>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
